var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { IMaskInput } from "react-imask";
import { MaskedInputStyles } from "./MaskedInput.styles";
export var MaskedInput = function (_a) {
    var iMaskProps = _a.iMaskProps, id = _a.id, name = _a.name, value = _a.value, onChange = _a.onChange, error = _a.error;
    var sx = MaskedInputStyles();
    return (_jsx(IMaskInput, __assign({ id: id, name: name, value: value, onAccept: onChange, style: sx.wrapper(error) }, iMaskProps)));
};
